<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="ok()">Ok</button>
</div>
